import {addDays, isSaturday, isSunday, differenceInCalendarDays, isSameDay} from 'date-fns'
import {EventOrder} from '../types/eventData'

export const getOrderTypeLabel = (order: EventOrder): string => {
  if (order?.homeTryOn) {
    return 'Home Try-On Order'
  }
  if (order?.exchange) {
    return 'Replacement Order'
  }
  return order?.rental ? 'Rental Order' : 'Purchase Order'
}

const BUSINESS_DAYS = 2
const isWeekend = (date: Date) => isSaturday(date) || isSunday(date)

const getCountOfWeekendDays = (currentDate: Date, eventDate: Date): number => {
  let weekendDays = 0

  for (let i = 1; i <= BUSINESS_DAYS; i += 1) {
    const followingDays = addDays(currentDate, i)
    const isNotEventDayButIsAWeekend =
      !isSameDay(followingDays, eventDate) && isWeekend(followingDays)

    if (isNotEventDayButIsAWeekend) weekendDays += 1
  }

  return weekendDays
}

export const isTwoOrMoreBusinessDaysAway = (eventDate: Date, currentDate = new Date()): boolean => {
  const differenceInCalDays = differenceInCalendarDays(eventDate, currentDate)

  if (differenceInCalDays < BUSINESS_DAYS) return false
  if (differenceInCalDays >= 4) return true

  const totalWeekendDays = getCountOfWeekendDays(currentDate, eventDate)

  if (differenceInCalDays === 2 && totalWeekendDays > 0) return false
  if (differenceInCalDays === 3 && totalWeekendDays > 1) return false

  return true
}
